/**
 * LINE OAuth callback landing（#24 Phase B）· route /line-callback。
 * backend callback 交換 token/profile 後導回此頁（?ok=1 或 ?err=1）；
 * ok → 輸入 TOTP 完成綁定；err → 顯示錯誤。
 */
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useMessage } from '../contexts/MessageContext';
import { bindLine } from '../services/lineLoginService';

const LineCallbackPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showSuccess, showApiError } = useMessage();
  const [params] = useSearchParams();
  const ok = params.get('ok') === '1';
  const [totp, setTotp] = useState('');
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    if (totp.length < 6) return;
    setBusy(true);
    try {
      const b = await bindLine(totp);
      showSuccess('SYS370001', { name: b.line_display_name || 'LINE' });
      navigate('/my_profile');
    } catch (err) { showApiError(err); }
    finally { setBusy(false); }
  };

  const box: React.CSSProperties = { maxWidth: 380, margin: '80px auto', padding: 24, border: '1px solid #e0e0e0', borderRadius: 8, textAlign: 'center' };
  const btn: React.CSSProperties = { padding: '8px 18px', border: 'none', borderRadius: 4, cursor: 'pointer', color: '#fff', background: '#06c755' };

  if (!ok) {
    return (
      <div style={box}>
        <h3>{t('lineLogin.confirmTitle', '完成 LINE 綁定')}</h3>
        <p style={{ color: '#d32f2f' }}>{t('lineLogin.callbackError', 'LINE 授權失敗，請重試')}</p>
        <button style={{ ...btn, background: '#1976d2' }} onClick={() => navigate('/my_profile')}>
          {t('common.back', '返回')}
        </button>
      </div>
    );
  }

  return (
    <div style={box}>
      <h3>{t('lineLogin.confirmTitle', '完成 LINE 綁定')}</h3>
      <p style={{ color: '#555' }}>{t('lineLogin.callbackSuccess', 'LINE 授權成功，請輸入驗證碼完成綁定')}</p>
      <input
        style={{ padding: '8px 10px', border: '1px solid #ccc', borderRadius: 4, width: '100%', marginBottom: 12, boxSizing: 'border-box' }}
        placeholder={t('lineLogin.totpLabel', '請輸入兩階段驗證碼')}
        value={totp} onChange={(e) => setTotp(e.target.value.trim())}
      />
      <div style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>{t('lineLogin.totpHint', '6 位驗證碼，或 8 碼備援碼')}</div>
      <button style={btn} disabled={busy} onClick={confirm}>{t('lineLogin.bindButton', '綁定 LINE')}</button>
    </div>
  );
};

export default LineCallbackPage;
